module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Water-mixer-9d1e683920712b59abe58be493d8db4c.svg";